<template>
  <!-- Products Page Component For Company From Company Profile Component -->
  <div class="tabs-content-firstblock" style="overflow-y: auto; overflow-x: hidden; height: 78em">
    <div class="row">
      <div class="col-lg-12">
        <div class="productspageHeader" v-if="account==$route.params.id && products.purchased_products && products.purchased_products.length ">
          <div class="descriptionheader">
            <div class="description-text-header-left">
              <h5>
                Purchased Products
              </h5>
            </div>
          </div>
        </div>
        <div class="row" v-if="ajaxCallinprogress">
            <div class="col-lg-12 py-5 px-3 mt-10">
                  <div class="flex-container">
                      <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" />
                  </div>
            </div>
        </div>
        <div class="row" v-if="!ajaxCallinprogress && !products.purchased_products && !products.purchased_products.length && products.not_purchased_products">
            <div class="col-lg-12 text-center py-3 px-3 mt-10">
                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/no_products_found.svg" class="img-fluid" style="width: 150px;">
                <h5 class="pt-3" style="color: #00448b;">No Products Found</h5>
            </div>
        </div>
        <div class="mt-5" v-else>
          <div class="products-section prodpage-uk-grid-width-small-1-100 prodpage-uk-grid-width-medium-1-47 prodpage-uk-grid-width-large-1-47 prodpage-uk-grid-width-xlarge-1-31">
            <div class="card-box products-box" v-for="(product,index) in products.purchased_products" :key="index">
              <div class="md-card products-card md-card-hover">
                <div class="md-card-head">
                  <div class="panel panel-body panel-prod prod-h">
                    <div class="" @click="openPage(product.public_url)" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;overflow: hidden;cursor:pointer;"></div>
                    <div class="mediaprod">
                      <div class="media-left" style="cursor: pointer;">
                        <a :href="product.public_url" target="_blank">
                          <img :src="product.logo">
                        </a>
                      </div>
                      <div class="media-body media-text-middle" @click="openPage(product.public_url)" style="cursor: pointer;">
                        <el-tooltip class="item" effect="dark" :content="product.product_name" placement="top">
                          <h6 class="media-heading prodpage-uk-text-truncate">
                            {{product.product_name}}
                          </h6>
                        </el-tooltip>
                      </div>
                      <div class="media-right media-middle" v-if="account==$route.params.id && (admin || superAdmin)">
                        <el-dropdown trigger="click">
                          <span class="el-dropdown-link">
                            <i class="icon-dots-vertical"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="unSubscribeToProduct(product._id)">Unsubscribe</el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="productspageHeader" v-if="account==$route.params.id && (admin || superAdmin) && products.not_purchased_products && products.not_purchased_products.length">
          <div class="descriptionheader">
            <div class="description-text-header-left">
              <h5>
                Products
              </h5>
            </div>
          </div>
        </div>

        <div class="mt-5" v-if="account==$route.params.id && (admin || superAdmin)">
          <div class="products-section prodpage-uk-grid-width-small-1-2 prodpage-uk-grid-width-medium-1-47 prodpage-uk-grid-width-large-1-47 prodpage-uk-grid-width-xlarge-1-3">
            <div class="card-box products-box" v-for="(product,index) in products.not_purchased_products" :key="index">
              <div class="md-card products-card md-card-hover">
                <div class="md-card-head">
                  <div class="panel panel-body panel-prod">
                    <div class="mediaprod">
                      <div class="media-left">
                        <a href="javascript:;">
                          <img :src="product.logo">
                        </a>
                      </div>
                      <div class="media-body">
                        <el-tooltip class="item" effect="dark" :content="product.product_name" placement="top">
                          <h6 class="media-heading prodpage-uk-text-truncate">
                            {{product.product_name}}
                          </h6>
                        </el-tooltip>
                        <span v-if="product.description">
                          <el-tooltip class="item" effect="dark" :content="product.description" placement="top">
                            <p class="prodpage-uk-text-truncate">{{product.description}}</p>
                          </el-tooltip>
                        </span>
                        <span v-else>
                          <p class="prodpage-uk-text-truncate">-</p>
                        </span>
                        <button class="btn btn-grey-outline btn-smm" @click="subscribeToProduct(product._id)">Subscribe</button>
                      </div>
                    </div>
                  </div>
                  <!-- <ul class="list-group">
										<li class="list-group-item three-line" onclick="window.open('http://pos.digicollect.com','new_window');">
											<div class="avatar">
												<i class="logo-pos"></i>
											</div>
											<div class="list-item-content">
												<el-tooltip class="item" effect="dark" content="DigiPOS" placement="top">
													<h3 class="prodpage-uk-text-truncate" onclick="window.open('http://pos.digicollect.com','new_window');">DigiPOS</h3>
												</el-tooltip>
												<el-tooltip class="item" effect="dark" content="Point of Sale" placement="top">
													<h4 class="prodpage-uk-text-truncate" onclick="window.open('http://pos.digicollect.com','new_window');">Point of Sale</h4>
												</el-tooltip>
												<p>
													<button class="btn btn-grey-outline btn-smm">Subscribe</button>
												</p>
											</div>
										</li>
									</ul> -->
                </div>
              </div>
            </div>
            <!-- <div class="card-box products-box">
							<div class="md-card products-card md-card-hover">
								<div class="md-card-head">
									<div class="panel panel-body panel-prod">
										<div class="mediaprod">
											<div class="media-left">
												<a href="http://wallet.digicollect.com" target="_blank">
													<i class="logo-pay"></i>
												</a>
											</div>
											<div class="media-body">
												<el-tooltip class="item" effect="dark" content="DigiPay" placement="top">
													<h6 class="media-heading prodpage-uk-text-truncate" onclick="window.open('http://wallet.digicollect.com','new_window');">
														DigiPay
													</h6>
												</el-tooltip>
												<el-tooltip class="item" effect="dark" content="Payment Gateway" placement="top">
													<p class="prodpage-uk-text-truncate">Payment Gateway</p>
												</el-tooltip>
												<button class="btn btn-grey-outline btn-smm">Subscribe</button>
											</div>
										</div>
									</div>
									<ul class="list-group">
										<li class="list-group-item three-line">
											<div class="avatar" onclick="window.open('http://wallet.digicollect.com','new_window');">
												<i class="logo-pay"></i>
											</div>
											<div class="list-item-content">
												<el-tooltip class="item" effect="dark" content="DigiPay" placement="top">
													<h3 class="prodpage-uk-text-truncate" onclick="window.open('http://wallet.digicollect.com','new_window');">DigiPay</h3>
												</el-tooltip>
												<el-tooltip class="item" effect="dark" content="Payment Gateway" placement="top">
													<h4 class="prodpage-uk-text-truncate" onclick="window.open('http://wallet.digicollect.com','new_window');">Payment Gateway</h4>
												</el-tooltip>
												<p>
													<button class="btn btn-grey-outline btn-smm">Subscribe</button>
												</p>
											</div>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div class="card-box products-box">
							<div class="md-card products-card md-card-hover">
								<div class="md-card-head">
									<div class="panel panel-body panel-prod">
										<div class="mediaprod">
											<div class="media-left">
												<a href="http://wallet.digicollect.com" target="_blank">
													<i class="logo-expence-management"></i>
												</a>
											</div>
											<div class="media-body">
												<el-tooltip class="item" effect="dark" content="Expense Management" placement="top">
													<h6 class="media-heading prodpage-uk-text-truncate" onclick="window.open('http://wallet.digicollect.com','new_window');">
														Expense Management
													</h6>
												</el-tooltip>
												<el-tooltip class="item" effect="dark" content="Manage Expense" placement="top">
													<p class="prodpage-uk-text-truncate">Manage Expense</p>
												</el-tooltip>
												<button class="btn btn-grey-outline btn-smm">Subscribe</button>
											</div>
										</div>
									</div>
									<ul class="list-group">
										<li class="list-group-item three-line">
											<div class="avatar">
												<i class="logo-expence-management"></i>
											</div>
											<div class="list-item-content">
												<el-tooltip class="item" effect="dark" content="Expense Management" placement="top">
													<h3 class="prodpage-uk-text-truncate">Expense Management</h3>
												</el-tooltip>
												<el-tooltip class="item" effect="dark" content="Manage Expense" placement="top">
													<h4 class="prodpage-uk-text-truncate">Manage Expense</h4>
												</el-tooltip>
												<p>
													<button class="btn btn-grey-outline btn-smm">Subscribe</button>
												</p>
											</div>
										</li>
									</ul>
								</div>
							</div>
						</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { HalfCircleSpinner } from 'epic-spinners'
export default {
  data() {
    return {
      products: {},
        ajaxCallinprogress: false,
    };
  },
  components: {
    HalfCircleSpinner
  },
  methods: {
    // Getting List of Purchased and Not Purchased Products
    getProductsPurchasedAndNotPurchased() {
      // TODO: put another check to see if account == route param
        this.ajaxCallinprogress = true;
      if (this.account) {
        this.$http
          .get("/company/get_products_purchased_not_purchased")
          .then(res => {
            if (res.data.status_id == 1) {
              this.products = res.data.response;
            }
            this.ajaxCallinprogress = false;
          });
      }
    },
    // Products URL Link and Redirection
    openPage(url) {
      window.open(url, "new_window");
    },

    // Product Purchase(Subscribe) For Company
    subscribeToProduct(product_id) {
        this.ajaxCallinprogress = true;
      this.$http
        .post("/company/add_digicollect_product_to_company", {
          product_id: product_id,
        })
        .then(res => {
          if (res.data.status_id == 1) {
            this.getProductsPurchasedAndNotPurchased();
            this.$swal({
              title: "Product Subscribed!",
              text: "Product Subscribed Successfully",
              type: "success",
              confirmButtonText: "OK",
              confirmButtonColor: "#005dae",
            });
          }
          else {
            // this.getProductsPurchasedAndNotPurchased();
            this.$swal({
              title: "Error!",
              text: "Product Subscription Failed!. Please Try Again",
              type: "error",
              confirmButtonText: "OK",
              confirmButtonColor: "#005dae",
            });
          }
          this.ajaxCallinprogress = false;
        });
    },

    // Remove (Unsubscribe) Products from Company
    unSubscribeToProduct(product_id) {
      this.$http
        .post("/company/remove_digicollect_product_from_company", {
          product_id: product_id,
        })
        .then(res => {
          if (res.data.status_id == 1) {
            this.getProductsPurchasedAndNotPurchased();
            this.$swal({
              title: "Product Unsubscribed!",
              text: "Product Unsubscribed Successfully",
              type: "success",
              confirmButtonText: "OK",
              confirmButtonColor: "#005dae",
            });
          } else {
            // this.getProductsPurchasedAndNotPurchased();
            this.$swal({
              title: "Error!",
              text: "Product Unsubscribe Failed!. Please Try Again",
              type: "error",
              confirmButtonText: "OK",
              confirmButtonColor: "#005dae",
            });
          }
        });
    },
  },
  created() {
    this.getProductsPurchasedAndNotPurchased();
  },
  computed: {
    account() {
      return this.$store.getters.account;
    },
    admin() {
      return this.$store.getters.isAdmin;
    },
    superAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
  },
};
</script>
<style>
.prodpage-uk-text-truncate {
  display: block;
}

.prodpage-uk-text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.panel.panel-prod {
  margin-bottom: 0px;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0px;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: inherit;
  padding: 0.8rem 1.2rem;
  cursor: default;
}
.panel.panel-prod.prod-h {
  padding: 1.8rem 1.2rem;
}
.panel-body.panel-prod:before {
  content: " ";
  display: table;
}
.mediaprod {
  margin-top: 0px;
  position: relative;
}
.mediaprod,
.mediaprod .media-body {
  zoom: 1;
  overflow: visible;
}
.mediaprod .media-body {
  display: table-cell;
  vertical-align: top;
  position: relative;
}
.mediaprod .media-body.media-text-middle {
  display: table-cell;
  vertical-align: middle;
  position: relative;
}
.mediaprod .media-left,
.mediaprod .media-right {
  display: table-cell;
  vertical-align: middle;
  position: relative;
}
.mediaprod .media-left {
  padding-right: 15px;
  cursor: pointer;
}
.mediaprod .media-left a {
  outline: 0;
  cursor: pointer;
  text-decoration: none;
  background-color: transparent;
}
.mediaprod .media-left a img {
    width: 40px;
    height: 40px;
    max-height: 40px;
    max-width: 40px;
    line-height: 40px;
}
.mediaprod .media-body {
  width: 10000px;
}
.mediaprod .media-left a i {
  width: 40px !important;
  height: 40px !important;
  line-height: 40px !important;
  vertical-align: middle;
  color: #fff;
  font-size: 40px;
}
.mediaprod .media-left a i.logo-crm {
  font-size: 25px;
}
.mediaprod .media-left a i.logo-pos {
  font-size: 30px;
}
.mediaprod .media-left a i.logo-pay {
  font-size: 25px;
}
.mediaprod .media-left a i.logo-cloud {
  font-size: 25px;
}
.mediaprod .media-left a i.logo-play {
  font-size: 25px;
}
.mediaprod .media-body h6.media-heading {
  margin-bottom: 2px;
  display: block;
  margin-top: 0;
  font-size: 15px;
  letter-spacing: -0.015em;
  line-height: 1.5384616;
  color: #fff;
  width: 145px;
  font-weight: bold;
  cursor: pointer;
}
.mediaprod .media-body p {
  margin: 0 0 10px;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.6px;
  margin: 1px 0 1px 0;
  color: #fff;
  max-width: 180px;
  height: 24px;
}
.mediaprod .media-right {
  padding-left: 5px;
}
.media-middle {
  vertical-align: middle;
}

.prodpage-uk-grid {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  list-style: none;
}
.prodpage-uk-grid:after,
.prodpage-uk-grid:before {
  content: "";
  display: block;
  overflow: hidden;
}
.prodpage-uk-grid:after {
  clear: both;
}
.prodpage-uk-grid > * {
  -ms-flex: none;
  -webkit-flex: none;
  flex: none;
  margin: 0;
  float: left;
}
.prodpage-uk-grid > * > :last-child {
  margin-bottom: 0;
}
.prodpage-uk-grid {
  margin-left: -25px;
}
.prodpage-uk-grid > * {
  padding-left: 25px;
}
.prodpage-uk-grid + .prodpage-uk-grid,
.prodpage-uk-grid-margin,
.prodpage-uk-grid > * > .prodpage-uk-panel + .prodpage-uk-panel {
  margin-top: 25px;
}
@media (min-width: 1220px) {
  .prodpage-uk-grid {
    margin-left: -35px;
  }
  .prodpage-uk-grid > * {
    padding-left: 35px;
  }
  .prodpage-uk-grid + .prodpage-uk-grid,
  .prodpage-uk-grid-margin,
  .prodpage-uk-grid > * > .prodpage-uk-panel + .prodpage-uk-panel {
    margin-top: 35px;
  }
}
.prodpage-uk-grid-collapse {
  margin-left: 0;
}
.prodpage-uk-grid-collapse > * {
  padding-left: 0;
}
.prodpage-uk-grid-collapse + .prodpage-uk-grid-collapse,
.prodpage-uk-grid-collapse > * > .prodpage-uk-panel + .prodpage-uk-panel,
.prodpage-uk-grid-collapse > .prodpage-uk-grid-margin {
  margin-top: 0;
}
.prodpage-uk-grid-small {
  margin-left: -10px;
}
.prodpage-uk-grid-small > * {
  padding-left: 10px;
}
.prodpage-uk-grid-small + .prodpage-uk-grid-small,
.prodpage-uk-grid-small > * > .prodpage-uk-panel + .prodpage-uk-panel,
.prodpage-uk-grid-small > .prodpage-uk-grid-margin {
  margin-top: 10px;
}
.prodpage-uk-grid-medium {
  margin-left: -25px;
}
.prodpage-uk-grid-medium > * {
  padding-left: 25px;
}
.prodpage-uk-grid-medium + .prodpage-uk-grid-medium,
.prodpage-uk-grid-medium > * > .prodpage-uk-panel + .prodpage-uk-panel,
.prodpage-uk-grid-medium > .prodpage-uk-grid-margin {
  margin-top: 25px;
}
@media (min-width: 960px) {
  .prodpage-uk-grid-large {
    margin-left: -35px;
  }
  .prodpage-uk-grid-large > * {
    padding-left: 35px;
  }
  .prodpage-uk-grid-large + .prodpage-uk-grid-large,
  .prodpage-uk-grid-large-margin,
  .prodpage-uk-grid-large > * > .prodpage-uk-panel + .prodpage-uk-panel {
    margin-top: 35px;
  }
}
@media (min-width: 1220px) {
  .prodpage-uk-grid-large {
    margin-left: -50px;
  }
  .prodpage-uk-grid-large > * {
    padding-left: 50px;
  }
  .prodpage-uk-grid-large + .prodpage-uk-grid-large,
  .prodpage-uk-grid-large-margin,
  .prodpage-uk-grid-large > * > .prodpage-uk-panel + .prodpage-uk-panel {
    margin-top: 50px;
  }
}
.prodpage-uk-grid-divider:not(:empty) {
  margin-left: -25px;
  margin-right: -25px;
}
.prodpage-uk-grid-divider > * {
  padding-left: 25px;
  padding-right: 25px;
}
.prodpage-uk-grid-divider > [class*="prodpage-uk-width-9-"]:nth-child(n + 2),
.prodpage-uk-grid-divider > [class*="prodpage-uk-width-1-"]:not(.prodpage-uk-width-1-1):nth-child(n + 2),
.prodpage-uk-grid-divider > [class*="prodpage-uk-width-2-"]:nth-child(n + 2),
.prodpage-uk-grid-divider > [class*="prodpage-uk-width-3-"]:nth-child(n + 2),
.prodpage-uk-grid-divider > [class*="prodpage-uk-width-4-"]:nth-child(n + 2),
.prodpage-uk-grid-divider > [class*="prodpage-uk-width-5-"]:nth-child(n + 2),
.prodpage-uk-grid-divider > [class*="prodpage-uk-width-6-"]:nth-child(n + 2),
.prodpage-uk-grid-divider > [class*="prodpage-uk-width-7-"]:nth-child(n + 2),
.prodpage-uk-grid-divider > [class*="prodpage-uk-width-8-"]:nth-child(n + 2) {
  border-left: 1px solid #ddd;
}
@media (min-width: 768px) {
  .prodpage-uk-grid-divider
    > [class*="prodpage-uk-width-medium-"]:not(.prodpage-uk-width-medium-1-1):nth-child(n + 2) {
    border-left: 1px solid #ddd;
  }
}
@media (min-width: 960px) {
  .prodpage-uk-grid-divider
    > [class*="prodpage-uk-width-large-"]:not(.prodpage-uk-width-large-1-1):nth-child(n + 2) {
    border-left: 1px solid #ddd;
  }
}
@media (min-width: 1220px) {
  .prodpage-uk-grid-divider:not(:empty) {
    margin-left: -35px;
    margin-right: -35px;
  }
  .prodpage-uk-grid-divider > * {
    padding-left: 35px;
    padding-right: 35px;
  }
  .prodpage-uk-grid-divider:empty {
    margin-top: 35px;
    margin-bottom: 35px;
  }
}
.prodpage-uk-grid-divider:empty {
  margin-top: 25px;
  margin-bottom: 25px;
  border-top: 1px solid #ddd;
}
.prodpage-uk-grid-match > * {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}
.prodpage-uk-grid-match > * > * {
  -ms-flex: none;
  -webkit-flex: none;
  flex: none;
  box-sizing: border-box;
  width: 100%;
}
/* [class*=prodpage-uk-grid-width]>*{
    box-sizing:border-box;
    width:100%
} */
.prodpage-uk-grid-width-1-2 > * {
  width: 50%;
}
.prodpage-uk-grid-width-1-3 > * {
  width: 33.333%;
}
.prodpage-uk-grid-width-1-4 > * {
  width: 25%;
}
.prodpage-uk-grid-width-1-5 > * {
  width: 20%;
}
.prodpage-uk-grid-width-1-6 > * {
  width: 16.666%;
}
.prodpage-uk-grid-width-1-10 > * {
  width: 10%;
}
.prodpage-uk-grid-width-auto > * {
  width: auto;
}
@media (min-width: 480px) {
  .prodpage-uk-grid-width-small-1-1 > * {
    width: 100%;
  }
  .prodpage-uk-grid-width-small-1-2 > * {
    width: 50%;
  }
  .prodpage-uk-grid-width-small-1-100 > * {
    width: 100%;
  }
  .prodpage-uk-grid-width-small-1-3 > * {
    width: 33.333%;
  }
  .prodpage-uk-grid-width-small-1-4 > * {
    width: 25%;
  }
  .prodpage-uk-grid-width-small-1-5 > * {
    width: 20%;
  }
  .prodpage-uk-grid-width-small-1-6 > * {
    width: 16.666%;
  }
  .prodpage-uk-grid-width-small-1-10 > * {
    width: 10%;
  }
}
@media (min-width: 768px) {
  .prodpage-uk-grid-width-medium-1-1 > * {
    width: 100%;
  }
  .prodpage-uk-grid-width-medium-1-2 > * {
    width: 50%;
  }
  .prodpage-uk-grid-width-medium-1-47 > * {
    width: 47.333%;
  }
  .prodpage-uk-grid-width-medium-1-3 > * {
    width: 33.333%;
  }
  .prodpage-uk-grid-width-medium-1-4 > * {
    width: 25%;
  }
  .prodpage-uk-grid-width-medium-1-5 > * {
    width: 20%;
  }
  .prodpage-uk-grid-width-medium-1-6 > * {
    width: 16.666%;
  }
  .prodpage-uk-grid-width-medium-1-10 > * {
    width: 10%;
  }
}
@media (min-width: 960px) {
  .prodpage-uk-grid-width-large-1-1 > * {
    width: 100%;
  }
  .prodpage-uk-grid-width-large-1-2 > * {
    width: 50%;
  }
  .prodpage-uk-grid-width-large-1-47 > * {
    width: 47.333%;
  }
  .prodpage-uk-grid-width-large-1-3 > * {
    width: 33.333%;
  }
  .prodpage-uk-grid-width-large-1-4 > * {
    width: 25%;
  }
  .prodpage-uk-grid-width-large-1-32 > * {
    width: 32%;
  }
  .prodpage-uk-grid-width-large-1-5 > * {
    width: 20%;
  }
  .prodpage-uk-grid-width-large-1-6 > * {
    width: 16.666%;
  }
  .prodpage-uk-grid-width-large-1-10 > * {
    width: 10%;
  }
}
@media (min-width: 1220px) {
  .prodpage-uk-grid-width-xlarge-1-1 > * {
    width: 100%;
  }
  .prodpage-uk-grid-width-xlarge-1-2 > * {
    width: 50%;
  }
  .prodpage-uk-grid-width-xlarge-1-3 > * {
    width: 33.333%;
  }
  .prodpage-uk-grid-width-xlarge-1-31 > * {
    width: 32.333%;
  }
  .prodpage-uk-grid-width-xlarge-1-4 > * {
    width: 25%;
  }
  .prodpage-uk-grid-width-xlarge-1-5 > * {
    width: 20%;
  }
  .prodpage-uk-grid-width-xlarge-1-24 > * {
    width: 24%;
  }
  .prodpage-uk-grid-width-xlarge-1-6 > * {
    width: 16.666%;
  }
  .prodpage-uk-grid-width-xlarge-1-16 > * {
    width: 16% !important;
  }
  .prodpage-uk-grid-width-xlarge-1-10 > * {
    width: 10%;
  }
}
[class*="prodpage-uk-width"] {
  box-sizing: border-box;
  width: 100%;
}
.prodpage-uk-grid-width-1-3 > * {
  width: 33.333%;
}
.prodpage-uk-grid-width-1-4 > * {
  width: 25%;
}
.prodpage-uk-grid-width-1-5 > * {
  width: 20%;
}
.prodpage-uk-grid-width-1-6 > * {
  width: 16.666%;
}
.prodpage-uk-grid-width-1-10 > * {
  width: 10%;
}
.prodpage-uk-grid-width-auto > * {
  width: auto;
}
@media (min-width: 480px) {
  .prodpage-uk-grid-width-small-1-1 > * {
    width: 100%;
  }
  .prodpage-uk-grid-width-small-1-2 > * {
    width: 50%;
  }
  .prodpage-uk-grid-width-small-1-3 > * {
    width: 33.333%;
  }
  .prodpage-uk-grid-width-small-1-4 > * {
    width: 25%;
  }
  .prodpage-uk-grid-width-small-1-5 > * {
    width: 20%;
  }
  .prodpage-uk-grid-width-small-1-6 > * {
    width: 16.666%;
  }
  .prodpage-uk-grid-width-small-1-10 > * {
    width: 10%;
  }
}
@media (min-width: 768px) {
  .prodpage-uk-grid-width-medium-1-1 > * {
    width: 100%;
  }
  .prodpage-uk-grid-width-medium-1-2 > * {
    width: 50%;
  }
  .prodpage-uk-grid-width-medium-1-47 > * {
    width: 47.333%;
  }
  .prodpage-uk-grid-width-medium-1-3 > * {
    width: 33.333%;
  }
  .prodpage-uk-grid-width-medium-1-4 > * {
    width: 25%;
  }
  .prodpage-uk-grid-width-medium-1-5 > * {
    width: 20%;
  }
  .prodpage-uk-grid-width-medium-1-6 > * {
    width: 16.666%;
  }
  .prodpage-uk-grid-width-medium-1-10 > * {
    width: 10%;
  }
}
@media (min-width: 960px) {
  .prodpage-uk-grid-width-large-1-1 > * {
    width: 100%;
  }
  .prodpage-uk-grid-width-large-1-2 > * {
    width: 50%;
  }
  .prodpage-uk-grid-width-large-1-47 > * {
    width: 47.333%;
  }
  .prodpage-uk-grid-width-large-1-3 > * {
    width: 33.333%;
  }
  .prodpage-uk-grid-width-large-1-4 > * {
    width: 25%;
  }
  .prodpage-uk-grid-width-large-1-32 > * {
    width: 32%;
  }
  .prodpage-uk-grid-width-large-1-5 > * {
    width: 20%;
  }
  .prodpage-uk-grid-width-large-1-6 > * {
    width: 16.666%;
  }
  .prodpage-uk-grid-width-large-1-10 > * {
    width: 10%;
  }
}
@media (min-width: 1220px) {
  .prodpage-uk-grid-width-xlarge-1-1 > * {
    width: 100%;
  }
  .prodpage-uk-grid-width-xlarge-1-2 > * {
    width: 50%;
  }
  .prodpage-uk-grid-width-xlarge-1-3 > * {
    width: 33.333%;
  }
  .prodpage-uk-grid-width-xlarge-1-31 > * {
    width: 32.333%;
  }
  .prodpage-uk-grid-width-xlarge-1-4 > * {
    width: 25%;
  }
  .prodpage-uk-grid-width-xlarge-1-5 > * {
    width: 20%;
  }
  .prodpage-uk-grid-width-xlarge-1-24 > * {
    width: 24%;
  }
  .prodpage-uk-grid-width-xlarge-1-6 > * {
    width: 16.666%;
  }
  .prodpage-uk-grid-width-xlarge-1-16 > * {
    width: 16% !important;
  }
  .prodpage-uk-grid-width-xlarge-1-10 > * {
    width: 10%;
  }
}
[class*="prodpage-uk-width"] {
  box-sizing: border-box;
  width: 100%;
}
.prodpage-uk-width-1-1 {
  width: 100%;
}
.prodpage-uk-width-1-2,
.prodpage-uk-width-2-4,
.prodpage-uk-width-3-6,
.prodpage-uk-width-5-10 {
  width: 50%;
}
.prodpage-uk-width-1-3,
.prodpage-uk-width-2-6 {
  width: 33.333%;
}
.prodpage-uk-width-2-3,
.prodpage-uk-width-4-6 {
  width: 66.666%;
}
.prodpage-uk-width-1-4 {
  width: 25%;
}
.prodpage-uk-width-3-4 {
  width: 75%;
}
.prodpage-uk-width-1-5,
.prodpage-uk-width-2-10 {
  width: 20%;
}
.prodpage-uk-width-2-5,
.prodpage-uk-width-4-10 {
  width: 40%;
}
.prodpage-uk-width-3-5,
.prodpage-uk-width-6-10 {
  width: 60%;
}
.prodpage-uk-width-4-5,
.prodpage-uk-width-8-10 {
  width: 80%;
}
.prodpage-uk-width-1-6 {
  width: 16.666%;
}
.prodpage-uk-width-5-6 {
  width: 83.333%;
}
.prodpage-uk-width-1-10 {
  width: 10%;
}
.prodpage-uk-width-3-10 {
  width: 30%;
}
.prodpage-uk-width-7-10 {
  width: 70%;
}
.prodpage-uk-width-9-10 {
  width: 90%;
}
@media (min-width: 480px) {
  .prodpage-uk-width-small-1-1 {
    width: 100%;
  }
  .prodpage-uk-width-small-1-2,
  .prodpage-uk-width-small-2-4,
  .prodpage-uk-width-small-3-6,
  .prodpage-uk-width-small-5-10 {
    width: 50%;
  }
  .prodpage-uk-width-small-1-3,
  .prodpage-uk-width-small-2-6 {
    width: 33.333%;
  }
  .prodpage-uk-width-small-2-3,
  .prodpage-uk-width-small-4-6 {
    width: 66.666%;
  }
  .prodpage-uk-width-small-1-4 {
    width: 25%;
  }
  .prodpage-uk-width-small-3-4 {
    width: 75%;
  }
  .prodpage-uk-width-small-1-5,
  .prodpage-uk-width-small-2-10 {
    width: 20%;
  }
  .prodpage-uk-width-small-2-5,
  .prodpage-uk-width-small-4-10 {
    width: 40%;
  }
  .prodpage-uk-width-small-3-5,
  .prodpage-uk-width-small-6-10 {
    width: 60%;
  }
  .prodpage-uk-width-small-4-5,
  .prodpage-uk-width-small-8-10 {
    width: 80%;
  }
  .prodpage-uk-width-small-1-6 {
    width: 16.666%;
  }
  .prodpage-uk-width-small-5-6 {
    width: 83.333%;
  }
  .prodpage-uk-width-small-1-10 {
    width: 10%;
  }
  .prodpage-uk-width-small-3-10 {
    width: 30%;
  }
  .prodpage-uk-width-small-7-10 {
    width: 70%;
  }
  .prodpage-uk-width-small-9-10 {
    width: 90%;
  }
}
@media (min-width: 768px) {
  .prodpage-uk-width-medium-1-1 {
    width: 100%;
  }
  .prodpage-uk-width-medium-1-2,
  .prodpage-uk-width-medium-2-4,
  .prodpage-uk-width-medium-3-6,
  .prodpage-uk-width-medium-5-10 {
    width: 50%;
  }
  .prodpage-uk-width-medium-1-3,
  .prodpage-uk-width-medium-2-6 {
    width: 33.333%;
  }
  .prodpage-uk-width-medium-2-3,
  .prodpage-uk-width-medium-4-6 {
    width: 66.666%;
  }
  .prodpage-uk-width-medium-1-4 {
    width: 25%;
  }
  .prodpage-uk-width-medium-3-4 {
    width: 75%;
  }
  .prodpage-uk-width-medium-1-5,
  .prodpage-uk-width-medium-2-10 {
    width: 20%;
  }
  .prodpage-uk-width-medium-2-5,
  .prodpage-uk-width-medium-4-10 {
    width: 40%;
  }
  .prodpage-uk-width-medium-3-5,
  .prodpage-uk-width-medium-6-10 {
    width: 60%;
  }
  .prodpage-uk-width-medium-4-5,
  .prodpage-uk-width-medium-8-10 {
    width: 80%;
  }
  .prodpage-uk-width-medium-1-6 {
    width: 16.666%;
  }
  .prodpage-uk-width-medium-5-6 {
    width: 83.333%;
  }
  .prodpage-uk-width-medium-1-10 {
    width: 10%;
  }
  .prodpage-uk-width-medium-3-10 {
    width: 30%;
  }
  .prodpage-uk-width-medium-7-10 {
    width: 70%;
  }
  .prodpage-uk-width-medium-9-10 {
    width: 90%;
  }
}
@media (min-width: 960px) {
  .prodpage-uk-width-large-1-1 {
    width: 100%;
  }
  .prodpage-uk-width-large-1-2,
  .prodpage-uk-width-large-2-4,
  .prodpage-uk-width-large-3-6,
  .prodpage-uk-width-large-5-10 {
    width: 50%;
  }
  .prodpage-uk-width-large-1-3,
  .prodpage-uk-width-large-2-6 {
    width: 33.333%;
  }
  .prodpage-uk-width-large-2-3,
  .prodpage-uk-width-large-4-6 {
    width: 66.666%;
  }
  .prodpage-uk-width-large-1-4 {
    width: 25%;
  }
  .prodpage-uk-width-large-3-4 {
    width: 75%;
  }
  .prodpage-uk-width-large-1-5,
  .prodpage-uk-width-large-2-10 {
    width: 20%;
  }
  .prodpage-uk-width-large-2-5,
  .prodpage-uk-width-large-4-10 {
    width: 40%;
  }
  .prodpage-uk-width-large-3-5,
  .prodpage-uk-width-large-6-10 {
    width: 60%;
  }
  .prodpage-uk-width-large-4-5,
  .prodpage-uk-width-large-8-10 {
    width: 80%;
  }
  .prodpage-uk-width-large-1-6 {
    width: 16.666%;
  }
  .prodpage-uk-width-large-5-6 {
    width: 83.333%;
  }
  .prodpage-uk-width-large-1-10 {
    width: 10%;
  }
  .prodpage-uk-width-large-3-10 {
    width: 30%;
  }
  .prodpage-uk-width-large-7-10 {
    width: 70%;
  }
  .prodpage-uk-width-large-9-10 {
    width: 90%;
  }
}
@media (min-width: 1220px) {
  .prodpage-uk-width-xlarge-1-1 {
    width: 100%;
  }
  .prodpage-uk-width-xlarge-1-2,
  .prodpage-uk-width-xlarge-2-4,
  .prodpage-uk-width-xlarge-3-6,
  .prodpage-uk-width-xlarge-5-10 {
    width: 50%;
  }
  .prodpage-uk-width-xlarge-1-3,
  .prodpage-uk-width-xlarge-2-6 {
    width: 33.333%;
  }
  .prodpage-uk-width-xlarge-2-3,
  .prodpage-uk-width-xlarge-4-6 {
    width: 66.666%;
  }
  .prodpage-uk-width-xlarge-1-4 {
    width: 25%;
  }
  .prodpage-uk-width-xlarge-3-4 {
    width: 75%;
  }
  .prodpage-uk-width-xlarge-1-5,
  .prodpage-uk-width-xlarge-2-10 {
    width: 20%;
  }
  .prodpage-uk-width-xlarge-2-5,
  .prodpage-uk-width-xlarge-4-10 {
    width: 40%;
  }
  .prodpage-uk-width-xlarge-3-5,
  .prodpage-uk-width-xlarge-6-10 {
    width: 60%;
  }
  .prodpage-uk-width-xlarge-4-5,
  .prodpage-uk-width-xlarge-8-10 {
    width: 80%;
  }
  .prodpage-uk-width-xlarge-1-6 {
    width: 16.666%;
  }
  .prodpage-uk-width-xlarge-5-6 {
    width: 83.333%;
  }
  .prodpage-uk-width-xlarge-1-10 {
    width: 10%;
  }
  .prodpage-uk-width-xlarge-3-10 {
    width: 30%;
  }
  .prodpage-uk-width-xlarge-7-10 {
    width: 70%;
  }
  .prodpage-uk-width-xlarge-9-10 {
    width: 90%;
  }
}
@media (min-width: 768px) {
  [class*="prodpage-uk-push-"],
  [class*="prodpage-uk-pull-"] {
    position: relative;
  }
  .prodpage-uk-push-1-2,
  .prodpage-uk-push-2-4,
  .prodpage-uk-push-3-6,
  .prodpage-uk-push-5-10 {
    left: 50%;
  }
  .prodpage-uk-push-1-3,
  .prodpage-uk-push-2-6 {
    left: 33.333%;
  }
  .prodpage-uk-push-2-3,
  .prodpage-uk-push-4-6 {
    left: 66.666%;
  }
  .prodpage-uk-push-1-4 {
    left: 25%;
  }
  .prodpage-uk-push-3-4 {
    left: 75%;
  }
  .prodpage-uk-push-1-5,
  .prodpage-uk-push-2-10 {
    left: 20%;
  }
  .prodpage-uk-push-2-5,
  .prodpage-uk-push-4-10 {
    left: 40%;
  }
  .prodpage-uk-push-3-5,
  .prodpage-uk-push-6-10 {
    left: 60%;
  }
  .prodpage-uk-push-4-5,
  .prodpage-uk-push-8-10 {
    left: 80%;
  }
  .prodpage-uk-push-1-6 {
    left: 16.666%;
  }
  .prodpage-uk-push-5-6 {
    left: 83.333%;
  }
  .prodpage-uk-push-1-10 {
    left: 10%;
  }
  .prodpage-uk-push-3-10 {
    left: 30%;
  }
  .prodpage-uk-push-7-10 {
    left: 70%;
  }
  .prodpage-uk-push-9-10 {
    left: 90%;
  }
  .prodpage-uk-pull-1-2,
  .prodpage-uk-pull-2-4,
  .prodpage-uk-pull-3-6,
  .prodpage-uk-pull-5-10 {
    left: -50%;
  }
  .prodpage-uk-pull-1-3,
  .prodpage-uk-pull-2-6 {
    left: -33.333%;
  }
  .prodpage-uk-pull-2-3,
  .prodpage-uk-pull-4-6 {
    left: -66.666%;
  }
  .prodpage-uk-pull-1-4 {
    left: -25%;
  }
  .prodpage-uk-pull-3-4 {
    left: -75%;
  }
  .prodpage-uk-pull-1-5,
  .prodpage-uk-pull-2-10 {
    left: -20%;
  }
  .prodpage-uk-pull-2-5,
  .prodpage-uk-pull-4-10 {
    left: -40%;
  }
  .prodpage-uk-pull-3-5,
  .prodpage-uk-pull-6-10 {
    left: -60%;
  }
  .prodpage-uk-pull-4-5,
  .prodpage-uk-pull-8-10 {
    left: -80%;
  }
  .prodpage-uk-pull-1-6 {
    left: -16.666%;
  }
  .prodpage-uk-pull-5-6 {
    left: -83.333%;
  }
  .prodpage-uk-pull-1-10 {
    left: -10%;
  }
  .prodpage-uk-pull-3-10 {
    left: -30%;
  }
  .prodpage-uk-pull-7-10 {
    left: -70%;
  }
  .prodpage-uk-pull-9-10 {
    left: -90%;
  }
}
.prodpage-uk-panel {
  display: block;
  position: relative;
}
.prodpage-uk-panel,
.prodpage-uk-panel:hover {
  text-decoration: none;
}
.prodpage-uk-panel:after,
.prodpage-uk-panel:before {
  content: "";
  display: table;
}
.prodpage-uk-panel:after {
  clear: both;
}
.prodpage-uk-panel > :not(.prodpage-uk-panel-title):last-child {
  margin-bottom: 0;
}
.prodpage-uk-panel-title {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 18px;
  line-height: 24px;
  font-weight: 400;
  text-transform: none;
  color: #444;
}
.prodpage-uk-panel-badge {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}
.prodpage-uk-panel-teaser {
  margin-bottom: 15px;
}
.prodpage-uk-panel-body {
  padding: 15px;
}
.prodpage-uk-panel-box {
  padding: 15px;
  background: #fafafa;
  color: #444;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.prodpage-uk-panel-box-hover:hover {
  color: #444;
}
.prodpage-uk-panel-box .prodpage-uk-panel-title {
  color: #444;
}
.prodpage-uk-panel-box .prodpage-uk-panel-badge {
  top: 10px;
  right: 10px;
}
.prodpage-uk-panel-box > .prodpage-uk-panel-teaser {
  margin-top: -16px;
  margin-left: -16px;
  margin-right: -16px;
}
.prodpage-uk-panel-box > .prodpage-uk-nav-side {
  margin: 0 -15px;
}
.prodpage-uk-panel-box-primary {
  background-color: #ebf7fd;
  color: #2d7091;
  border-color: rgba(45, 112, 145, 0.3);
}
.prodpage-uk-panel-box-primary-hover:hover {
  color: #2d7091;
}
.prodpage-uk-panel-box-primary .prodpage-uk-panel-title {
  color: #2d7091;
}
.prodpage-uk-panel-box-secondary {
  background-color: #fff;
  color: #444;
}
.prodpage-uk-panel-box-secondary-hover:hover {
  color: #444;
}
.prodpage-uk-panel-box-secondary .prodpage-uk-panel-title {
  color: #444;
}
.prodpage-uk-panel-hover {
  padding: 15px;
  color: #444;
  border: 1px solid transparent;
  border-radius: 4px;
}
.prodpage-uk-panel-hover:hover {
  background: #fafafa;
  color: #444;
  border-color: #ddd;
}
.prodpage-uk-panel-hover .prodpage-uk-panel-badge {
  top: 10px;
  right: 10px;
}
.prodpage-uk-panel-hover > .prodpage-uk-panel-teaser {
  margin-top: -16px;
  margin-left: -16px;
  margin-right: -16px;
}
.prodpage-uk-panel-header .prodpage-uk-panel-title {
  padding-bottom: 10px;
  border-bottom: 1px solid #ddd;
  color: #444;
}
.prodpage-uk-panel-space {
  padding: 30px;
}
.prodpage-uk-panel-space .prodpage-uk-panel-badge {
  top: 30px;
  right: 30px;
}
.prodpage-uk-panel + .prodpage-uk-panel-divider {
  margin-top: 50px !important;
}
.prodpage-uk-panel + .prodpage-uk-panel-divider:before {
  content: "";
  display: block;
  position: absolute;
  top: -25px;
  left: 0;
  right: 0;
  border-top: 1px solid #ddd;
}
@media (min-width: 1220px) {
  .prodpage-uk-panel + .prodpage-uk-panel-divider {
    margin-top: 70px !important;
  }
  .prodpage-uk-panel + .prodpage-uk-panel-divider:before {
    top: -35px;
  }
}
.prodpage-uk-panel-box .prodpage-uk-panel-teaser {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  overflow: hidden;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}
.prodpage-uk-block {
  position: relative;
  box-sizing: border-box;
  padding-top: 20px;
  padding-bottom: 20px;
}
@media (min-width: 768px) {
  .prodpage-uk-block {
    padding-top: 50px;
    padding-bottom: 50px;
  }
}
.prodpage-uk-block:after,
.prodpage-uk-block:before {
  content: "";
  display: table;
}
.prodpage-uk-block:after {
  clear: both;
}
.prodpage-uk-block > :last-child {
  margin-bottom: 0;
}
.prodpage-uk-block-large {
  padding-top: 20px;
  padding-bottom: 20px;
}
@media (min-width: 768px) {
  .prodpage-uk-block-large {
    padding-top: 50px;
    padding-bottom: 50px;
  }
}
@media (min-width: 960px) {
  .prodpage-uk-block-large {
    padding-top: 100px;
    padding-bottom: 100px;
  }
}
.prodpage-uk-block-default {
  background: #fff;
}
.prodpage-uk-block-muted {
  background: #f9f9f9;
}
.prodpage-uk-block-primary {
  background: #00a8e6;
}
.prodpage-uk-block-secondary {
  background: #222;
}
.prodpage-uk-block-default + .prodpage-uk-block-default,
.prodpage-uk-block-muted + .prodpage-uk-block-muted,
.prodpage-uk-block-primary + .prodpage-uk-block-primary,
.prodpage-uk-block-secondary + .prodpage-uk-block-secondary {
  padding-top: 0;
}
.md-card.products-card {
  position: relative;
  cursor: pointer;
  border-radius: 6px;
  -webkit-backdrop-filter: blur(30px);
  backdrop-filter: blur(30px);
  border: solid 0px #00448b;
  background-color: #00448b;
}
.md-card.products-card + .md-card.products-card,
.md-card.products-card + .prodpage-uk-grid,
.prodpage-uk-grid + .md-card.products-card {
  margin-top: 25px;
}
.md-card.products-card .full_width_in_card {
  padding: 16px 24px;
  background: rgba(0, 0, 0, 0.085);
}
.md-card.products-card .md-card-toolbar {
  height: 48px;
  padding: 0 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  background: #fff;
}
.md-card.products-card .md-card-toolbar:after,
.md-card.products-card .md-card-toolbar:before {
  content: " ";
  display: table;
}
.md-card.products-card .md-card-toolbar:after {
  clear: both;
}
.md-card.products-card .md-card-toolbar:after,
.md-card.products-card .md-card-toolbar:before {
  content: " ";
  display: table;
}
.md-card.products-card .md-card-toolbar:after {
  clear: both;
}
.md-card.products-card .md-card-toolbar-heading-text {
  font: 500 14px/50px Roboto, sans-serif;
  color: #212121;
  margin: 0;
  float: left;
  overflow: hidden;
  height: 48px;
}
.md-card.products-card .md-card-toolbar-heading-text.large {
  font-size: 18px;
  font-weight: 400;
}
.md-card.products-card .md-card-toolbar .md-toggle-group {
  float: left;
  margin: 8px 0 0 16px;
}
.md-card.products-card .md-card-toolbar .md-toggle-group.md-toggle-group-small {
  margin-top: 10px;
}
.md-card.products-card .md-card-toolbar .md-card-toolbar-actions {
  float: right;
  padding-top: 10px;
}
.md-card.products-card
  .md-card-toolbar
  .md-card-toolbar-actions
  .prodpage-uk-open
  .md-card-toolbar-icon {
  background: rgba(0, 0, 0, 0.085);
  color: #212121;
}
.md-card.products-card
  .md-card-toolbar
  .md-card-toolbar-actions
  .md-card-dropdown {
  display: inline-block;
  position: relative;
}
.md-card.products-card
  .md-card-toolbar
  .md-card-toolbar-actions
  .selectize-control {
  min-width: 220px;
  margin-top: -3px;
}
.md-card.products-card
  .md-card-toolbar
  .md-card-toolbar-actions
  .selectize-control
  .selectize-input {
  min-height: 30px;
  padding: 4px 8px;
}
.md-card.products-card
  .md-card-toolbar
  .md-card-toolbar-actions
  .selectize-control
  .selectize-dropdown {
  margin-top: -34px;
}
.md-card.products-card .md-card-toolbar .md-icon + .md-card-dropdown {
  margin-left: 4px;
}
.md-card.products-card .md-card-toolbar .md-card-fullscreen-deactivate {
  margin: 9px 8px 0 0;
}
.md-card.products-card .md-card-toolbar-input {
  border: none;
  font: 400 18px/24px Roboto, sans-serif;
  height: auto;
  background: 0 0 !important;
  padding: 12px 0;
  width: 50%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.md-card.products-card .md-card-toolbar .prodpage-uk-tab {
  margin-top: -2px;
  border-bottom: none;
}
.md-card.products-card .md-card-toolbar .prodpage-uk-tab li > a {
  padding: 10px 8px !important;
}
.md-card.products-card .md-card-head {
  height: auto;
  position: relative;
  border-bottom: 1px solid transparent;
}
.md-card.products-card:hover {
  -webkit-box-shadow: 0 4px 11px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 4px 11px 0 rgba(0, 0, 0, 0.15);
}
.md-card.products-card .md-card-head-menu {
  position: absolute;
  right: 8px;
  top: 8px;
  border: 1px solid #e0e3e6;
  border-radius: 4px;
  background: #fff;
}
.profile-img-div {
  background-color: rgba(255, 255, 255, 0);
  width: 86px;
  height: 86px;
  border-radius: 50%;
  margin-top: 20px;
  display: inline-block;
  border: 2px solid;
}
.md-card.products-card .md-card-head-avatar {
  width: 75px;
  height: 75px;
  border-radius: 50%;
  margin-top: 4px;
  display: inline-block;
}
.md-card.products-card .md-card-head-text {
  padding: 8px 10px 8px;
  font-size: 15px;
  color: #00448b;
  margin: 0;
  font-weight: 600;
  line-height: 1.19;
}
.md-card.products-card .md-card-head-text span:not(.listNavSelector) {
  display: block;
  font-size: 13px;
  margin-top: 5px;
  margin-bottom: 0px;
  color: #00448b;
  font-weight: 400;
  line-height: 1.25;
}
.md-card.products-card .md-card-head-text.text_dark {
  color: #303031 !important;
}
.md-card.products-card .md-card-head-text-over {
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(0, 0, 0, 0.65)),
    to(rgba(0, 0, 0, 0))
  );
  background-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.65) 0,
    rgba(0, 0, 0, 0) 100%
  );
}
.md-card.products-card .md-card-head-subtext {
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  padding: 0 16px;
  text-align: right;
  color: #fff;
}
.md-card.products-card .md-card-head-subtext span {
  font-size: 26px;
}
.md-card.products-card .md-card-head-icon {
  font-size: 48px;
  color: #fff;
  vertical-align: middle;
}
.md-card.products-card .md-card-head.head_background {
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  border-bottom-color: transparent;
}
.md-card.products-card .md-card-head.head_background .md-card-head-text {
  color: #fff;
}
.md-card.products-card .md-card-head.head_background_top {
  background-repeat: no-repeat;
  background-position: center top;
}
.md-card.products-card .md-card-head.head_background_bottom {
  background-repeat: no-repeat;
  background-position: center bottom;
}
.md-card.products-card .md-card-head .head_chart {
  height: 100px;
  width: 100%;
  position: absolute !important;
  left: 0;
  top: 40px;
}
.md-card.products-card .md-card-head .fitVid_player {
  width: 100%;
  height: 160px;
  overflow: hidden;
}
.md-card.products-card .md-card-head-img {
  height: 100%;
  width: auto;
}
.md-card.products-card .md-card-head iframe {
  height: 160px;
}
.md-card.products-card .md-card-content {
  padding: 5px 12px 12px;
}
.md-card.products-card .md-card-content.padding-reset {
  padding: 0;
}
.md-card.products-card .md-card-content.large-padding {
  padding: 24px 35px;
}
.md-card.products-card .md-card-content.small-padding {
  padding: 8px;
}
.md-card.md-card-fullscreen-activate {
  cursor: pointer;
}
.md-card.md-card-fullscreen {
  position: fixed;
  z-index: 9998;
  overflow-x: hidden;
  cursor: default;
}
.md-card.md-card-fullscreen .md-card-fullscreen-activate {
  display: none;
}
.md-card.md-card-fullscreen .md-card-fullscreen-hide {
  display: none;
}
.md-card.products-card .md-card-fullscreen-content {
  display: none;
  padding: 16px;
}
.md-card-fullscreen-content-hidden
  .md-card.products-card
  .md-card-fullscreen-content {
  display: block;
  visibility: hidden;
  padding: 0;
}
.md-card.mdToolbar_fixed {
  overflow-y: hidden;
}
.md-card.mdToolbar_fixed > .md-card-toolbar {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 9999;
  -webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16),
    0 3px 6px rgba(0, 0, 0, 0.23);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}
.md-card.mdToolbar_fixed > .md-card-content {
  overflow-y: scroll;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  width: 100%;
  top: 48px;
  bottom: 0;
}
.md-card.mdToolbar_fixed > .md-card-content .md-card-fullscreen-content {
  padding: 16px 0;
}
.md-card.products-card.md-card-overlay {
  overflow: hidden;
  padding-bottom: 54px;
}
.md-card.products-card .md-card-overlay .md-card-content {
  height: 142px;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.md-card.products-card .md-card-overlay .md-card-content.no_truncate {
  position: relative;
}
.md-card.products-card.md-card-overlay .md-card-content.no_truncate:after {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 8px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(50%, #fff),
    to(rgba(255, 255, 255, 0))
  );
  background-image: linear-gradient(
    to top,
    #fff 50%,
    rgba(255, 255, 255, 0) 100%
  );
  display: block;
  content: "";
  z-index: 10;
}
.md-card.products-card.md-card-overlay .md-card-content > pre {
  margin-top: 0;
  max-height: 110px;
}
.md-card.products-card.md-card-overlay .md-card-content > pre > code {
  overflow: hidden;
}
.md-card.products-card.md-card-overlay .md-card-overlay-content {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  padding: 0 16px;
  margin-top: -54px;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  text-align: left;
  bottom: 0;
  background: #fff;
  z-index: 10;
  -webkit-transition: all 280ms cubic-bezier(0.4, 0, 0.2, 1);
  transition: all 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.md-card.products-card.md-card-overlay .md-card-overlay-content p {
  margin: 0;
}
.md-card.products-card.md-card-overlay .md-card-overlay-content p + * {
  margin-top: 16px;
}
.md-card.products-card.md-card-overlay .md-card-overlay-content p + p {
  margin-top: 4px;
}
.md-card.products-card.md-card-overlay .md-card-overlay-header {
  padding: 12px 0;
}
.md-card.products-card.md-card-overlay .md-card-overlay-header:after,
.md-card.products-card.md-card-overlay .md-card-overlay-header:before {
  content: " ";
  display: table;
}
.md-card.products-card.md-card-overlay .md-card-overlay-header:after {
  clear: both;
}
.md-card.products-card.md-card-overlay .md-card-overlay-header:after,
.md-card.products-card.md-card-overlay .md-card-overlay-header:before {
  content: " ";
  display: table;
}
.md-card.products-card.md-card-overlay .md-card-overlay-header:after {
  clear: both;
}
.md-card.products-card.md-card-overlay .md-card-overlay-header h3,
.md-card.products-card.md-card-overlay .md-card-overlay-header h4 {
  margin: 0;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  padding-right: 32px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.md-card.products-card.md-card-overlay .md-card-overlay-header .md-icon {
  position: absolute;
  right: 12px;
  top: 11px;
}
.md-card.products-card.md-card-overlay-active .md-card-overlay-content {
  top: -1px;
  margin-top: 0;
}
/* .md-card.md-card-hover{
    -webkit-transition:all 280ms cubic-bezier(.4,0,.2,1);
    transition:all 280ms cubic-bezier(.4,0,.2,1);
    will-change:box-shadow
}
.md-card.md-card-hover:hover{
    -webkit-box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23);
    box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23)
} */
.prodpage-uk-sortable-dragged .md-card {
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19),
    0 6px 6px rgba(0, 0, 0, 0.23);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
}
.prodpage-uk-sortable-dragged .md-card.products-card canvas {
  margin: 0 auto;
  display: block;
}
.md-card.products-card .heading_list {
  padding: 0;
}
.md-card-danger,
.md-card-primary,
.md-card-success,
.md-card-warning {
  border-left: 4px solid transparent;
}
.md-card-primary {
  border-left-color: #00448b;
}
.md-card-success {
  border-left-color: #7cb342;
}
.md-card-danger {
  border-left-color: #e53935;
}
.md-card-warning {
  border-left-color: #ffa000;
}
.md-card-horizontal {
  position: relative;
  min-height: 200px;
}
.md-card-horizontal:after,
.md-card-horizontal:before {
  content: " ";
  display: table;
}
.md-card-horizontal:after {
  clear: both;
}
.md-card-horizontal:after,
.md-card-horizontal:before {
  content: " ";
  display: table;
}
.md-card-horizontal:after {
  clear: both;
}
.md-card-horizontal-grid {
  min-height: auto;
}
.md-card-horizontal .md-card-head {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  border-bottom: none;
  width: 200px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
}
@media only screen and (max-width: 767px) {
  .md-card-horizontal .md-card-head {
    width: 140px;
  }
}
.md-card-horizontal .md-card-head-grid {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}
.md-card-horizontal .md-card-head-menu {
  right: auto;
  left: 8px;
}
.md-card-horizontal .md-card-content {
  margin-left: 200px;
}
@media only screen and (max-width: 767px) {
  .md-card-horizontal .md-card-content {
    margin-left: 140px;
  }
}
.md-card-horizontal .md-card-content-grid {
  padding: 16px;
}
.md-expand,
.md-expand-group > * {
  opacity: 0;
}
.md-card-placeholder {
  min-width: 100%;
}
.md-card-list-wrapper,
.md-card-list-wrapper *,
.md-card-list-wrapper :after,
.md-card-list-wrapper :before,
.md-card-list-wrapper:after,
.md-card-list-wrapper:before {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.md-card-list-wrapper .md-card-list-header {
  position: absolute;
  top: -24px;
  left: 0;
}
.md-card-list-wrapper .md-card-list {
  margin: 48px 0 0 0;
  position: relative;
}
.md-card-list-wrapper .md-card-list:first-child {
  margin-top: 24px;
}
.md-card-list-wrapper .md-card-list > ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.md-card-list-wrapper .md-card-list > ul > li {
  padding: 0;
  margin: 0;
  list-style: none;
}
.md-card-list-wrapper .md-card-list > ul > li {
  min-height: 34px;
  padding: 8px 16px;
  font-size: 13px;
  -webkit-transition: background 150ms, padding 0.2s;
  transition: background 150ms, padding 0.2s;
  background: #fff;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
    0 1px 2px rgba(0, 0, 0, 0.24);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.md-card-list-wrapper .md-card-list > ul > li:after,
.md-card-list-wrapper .md-card-list > ul > li:before {
  content: " ";
  display: table;
}
.md-card-list-wrapper .md-card-list > ul > li:after {
  clear: both;
}
.md-card-list-wrapper .md-card-list > ul > li:after,
.md-card-list-wrapper .md-card-list > ul > li:before {
  content: " ";
  display: table;
}
.md-card-list-wrapper .md-card-list > ul > li:after {
  clear: both;
}
.md-card-list-wrapper .md-card-list > ul > li.item-shown {
  background: #fff;
  padding: 8px 36px;
}
@media only screen and (max-width: 767px) {
  .md-card-list-wrapper
    .md-card-list
    > ul
    > li.item-shown
    .md-card-list-item-subject {
    clear: both;
    float: none;
    padding-top: 16px;
  }
  .md-card-list-wrapper
    .md-card-list
    > ul
    > li.item-shown
    .md-card-list-item-subject
    > span {
    white-space: normal;
  }
}
.md-card-list-wrapper
  .md-card-list
  > ul
  > li.item-shown
  .md-card-list-item-sender {
  width: auto;
  overflow: hidden;
}
.md-card-list-wrapper
  .md-card-list
  > ul
  > li.item-shown.md-card-list-item-selected {
  position: relative;
}
.md-card-list-wrapper
  .md-card-list
  > ul
  > li.item-shown.md-card-list-item-selected:before {
  content: "";
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  bottom: 0;
  width: 8px;
  background: #e3f2fd;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-avatar-wrapper,
.md-card-list-wrapper .md-card-list .md-card-list-item-select,
.md-card-list-wrapper .md-card-list .md-card-list-item-sender {
  float: left;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-select {
  padding: 6px 8px 0 0;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-avatar-wrapper,
.md-card-list-wrapper .md-card-list .md-card-list-item-date,
.md-card-list-wrapper .md-card-list .md-card-list-item-sender,
.md-card-list-wrapper .md-card-list .md-card-list-item-subject {
  padding: 0 8px;
}
.md-card-list-wrapper
  .md-card-list
  .md-card-list-item-avatar-wrapper
  .md-card-list-item-avatar {
  background: #757575;
  color: #fff;
  width: 34px;
  border-radius: 50%;
  display: block;
}
.md-card-list-wrapper
  .md-card-list
  .md-card-list-item-avatar-wrapper
  .md-card-list-item-avatar-large {
  width: 82px;
  border-radius: 50%;
}
.md-card-list-wrapper
  .md-card-list
  .md-card-list-item-avatar-wrapper
  span.md-card-list-item-avatar {
  line-height: 34px;
  text-transform: uppercase;
  text-align: center;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-sender {
  width: 220px;
  line-height: 34px;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-sender > span {
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
}
@media only screen and (max-width: 1219px) {
  .md-card-list-wrapper .md-card-list .md-card-list-item-sender {
    display: none;
  }
}
.md-card-list-wrapper .md-card-list .md-card-list-item-subject {
  overflow: hidden;
  font-weight: 500;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-subject > span {
  line-height: 34px;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
}
.md-card-list-wrapper
  .md-card-list
  .md-card-list-item-subject
  .md-card-list-item-sender-small {
  display: none;
}
@media only screen and (max-width: 1219px) {
  .md-card-list-wrapper
    .md-card-list
    .md-card-list-item-subject
    .md-card-list-item-sender-small {
    display: block;
  }
  .md-card-list-wrapper
    .md-card-list
    .md-card-list-item-subject
    .md-card-list-item-sender-small
    + span {
    line-height: inherit;
  }
}
.md-card-list-wrapper
  .md-card-list
  .md-card-list-item-subject
  .md-card-list-item-sender-small
  > span {
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  font-size: 12px;
  color: #999;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-date {
  line-height: 34px;
  float: right;
  color: #999;
}
@media only screen and (max-width: 479px) {
  .md-card-list-wrapper .md-card-list .md-card-list-item-date {
    display: none;
  }
}
.md-card-list-wrapper .md-card-list .md-card-list-item-menu {
  float: right;
  margin: 0 0 0 8px;
  position: relative;
}
.md-card-list-wrapper
  .md-card-list
  .md-card-list-item-menu
  .prodpage-uk-dropdown
  .material-icons {
  margin-right: 8px;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-content-wrapper {
  display: none;
  clear: both;
  opacity: 0;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-content {
  padding: 16px 16px 0 0;
  max-height: 360px;
  overflow-x: hidden;
  margin: 0 0 40px;
  top: 20px;
  position: relative;
  font-size: 14px;
}
.md-card-list-wrapper
  .md-card-list
  .md-card-list-item-content
  + .md-card-list-item-reply {
  padding-top: 10px;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-reply {
  padding: 16px 0;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-selected {
  background: #e3f2fd;
}
.md-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.md-list > li {
  padding: 0;
  margin: 0;
  list-style: none;
}
.md-list,
.md-list *,
.md-list :after,
.md-list :before,
.md-list:after,
.md-list:before {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.md-list .prodpage-uk-nestable-list > li,
.md-list > li {
  min-height: 48px;
  padding: 8px 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  position: relative;
}
.md-list .prodpage-uk-nestable-list > li > .md-list-content,
.md-list > li > .md-list-content {
  overflow: hidden;
}
.md-list .prodpage-uk-nestable-list > li > .md-list-content > span,
.md-list > li > .md-list-content > span {
  display: block;
}
.md-list .prodpage-uk-nestable-list > li > .md-list-content .md-list-heading,
.md-list > li > .md-list-content .md-list-heading {
  margin: 0;
  font-weight: 500;
  display: block;
  overflow: hidden;
  padding-bottom: 1px;
}
.md-list .prodpage-uk-nestable-list > li > .md-list-content .md-list-menu,
.md-list > li > .md-list-content .md-list-menu {
  float: right;
}
.md-list
  .prodpage-uk-nestable-list
  > li
  > .md-list-content
  .md-list-menu
  .md-list-menu-toggle,
.md-list > li > .md-list-content .md-list-menu .md-list-menu-toggle {
  display: block;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.8);
  width: 28px;
  height: 28px;
  line-height: 28px;
  border-radius: 14px;
  text-align: center;
}
.md-list .prodpage-uk-nestable-list > li > .md-list-content .prodpage-uk-badge,
.md-list > li > .md-list-content .prodpage-uk-badge {
  float: right;
  color: #fff !important;
}
.md-list .prodpage-uk-nestable-list > li > .md-list-content .md-list-action,
.md-list > li > .md-list-content .md-list-action {
  float: right;
  margin-left: 8px;
  margin-top: 2px;
  display: none;
}
.md-list .prodpage-uk-nestable-list > li > .md-list-content .md-list-action-placeholder,
.md-list > li > .md-list-content .md-list-action-placeholder {
  float: right;
  margin-left: 8px;
  display: none;
  width: 32px;
  height: 32px;
}
.md-list .prodpage-uk-nestable-list > li .md-list-action-dropdown,
.md-list > li .md-list-action-dropdown {
  position: absolute;
  right: 16px;
  top: 10px;
  display: none;
}
.md-list .prodpage-uk-nestable-list > li > a.md-list-content,
.md-list > li > a.md-list-content {
  display: block;
  color: #212121;
}
.md-list .prodpage-uk-nestable-list > li:last-child,
.md-list > li:last-child {
  border-bottom: none;
}
.md-list .prodpage-uk-nestable-list > li.md-list-item-active,
.md-list > li.md-list-item-active {
  color: #7cb342;
  background: #ededed;
}
.md-list .prodpage-uk-nestable-list > li.md-list-item-disabled > .md-list-content,
.md-list > li.md-list-item-disabled > .md-list-content {
  color: #bdbdbd;
}
.md-list .prodpage-uk-nestable-list > li.md-list-item-disabled > .md-list-content span,
.md-list > li.md-list-item-disabled > .md-list-content span {
  color: #bdbdbd !important;
}
.md-list .prodpage-uk-nestable-list > li.heading_list,
.md-list > li.heading_list {
  min-height: 32px;
  padding: 32px 8px 16px;
  border-bottom: none;
  background: 0 0 !important;
  text-transform: uppercase;
}
.md-list
  .prodpage-uk-nestable-list
  > li:hover
  > .md-list-addon-element
  .prodpage-uk-nestable-handle,
.md-list > li:hover > .md-list-addon-element .prodpage-uk-nestable-handle,
.prodpage-uk-touch
  .md-list
  .prodpage-uk-nestable-list
  > li
  > .md-list-addon-element
  .prodpage-uk-nestable-handle,
.prodpage-uk-touch .md-list > li > .md-list-addon-element .prodpage-uk-nestable-handle {
  display: block;
}
.md-list .prodpage-uk-nestable-list > li:hover > .md-list-content .md-list-action,
.md-list
  .prodpage-uk-nestable-list
  > li:hover
  > .md-list-content
  .md-list-action-placeholder,
.md-list > li:hover > .md-list-content .md-list-action,
.md-list > li:hover > .md-list-content .md-list-action-placeholder,
.prodpage-uk-touch .md-list .prodpage-uk-nestable-list > li > .md-list-content .md-list-action,
.prodpage-uk-touch
  .md-list
  .prodpage-uk-nestable-list
  > li
  > .md-list-content
  .md-list-action-placeholder,
.prodpage-uk-touch .md-list > li > .md-list-content .md-list-action,
.prodpage-uk-touch .md-list > li > .md-list-content .md-list-action-placeholder {
  display: block;
}
.md-list .prodpage-uk-nestable-list > li:hover .md-list-action-dropdown,
.md-list > li:hover .md-list-action-dropdown,
.prodpage-uk-touch .md-list .prodpage-uk-nestable-list > li .md-list-action-dropdown,
.prodpage-uk-touch .md-list > li .md-list-action-dropdown {
  display: block;
}
.md-list .prodpage-uk-nestable-list > li {
  margin-left: 64px;
}
.md-list-addon > li {
  margin-left: 64px;
  position: relative;
}
.md-list-addon > li:last-child .md-list-addon-element {
  border-bottom: none;
  bottom: 0;
}
.md-list-addon > li:first-child .md-list-addon-element {
  top: 0;
}
.md-list-addon > li.md-list-item-active .md-list-addon-element,
.md-list-addon > li.md-list-item-active .md-list-addon-element .material-icons {
  color: #7cb342;
}
.md-list-addon-element {
  position: absolute;
  left: -64px;
  top: -1px;
  bottom: -1px;
  width: 64px;
  text-align: center;
  padding: 8px 0;
  display: block;
}
.md-list-addon-element .element-status {
  position: absolute;
  right: 12px;
  top: 10px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #bdbdbd;
  border: 1px solid #fff;
}
.md-list-addon-element .element-status-danger {
  background: #e53935;
}
.md-list-addon-element .element-status-success {
  background: #7cb342;
}
.md-list-addon-element .element-status-warning {
  background: #ffa000;
}
.md-list-addon-element > .md-list-addon-avatar {
  margin-top: 2px;
}
.md-list-addon-element > .md-list-addon-icon {
  font-size: 28px;
  margin-top: 4px;
  color: #727272;
}
.md-list-addon-element > .material-icons {
  margin-top: 6px;
}
.md-list-addon-element .icheckbox_md,
.md-list-addon-element .iradio_md {
  margin-top: 10px;
}
.md-list-addon-element .prodpage-uk-nestable-handle {
  position: absolute;
  left: -2px;
  top: 12px;
  display: none;
}
.md-list-interactive li {
  cursor: pointer;
}
.md-list-bg {
  background: #fff;
}
.md-list-separated li {
  background: #fff;
  padding: 8px;
}
.md-list-separated li + li {
  border-top: none;
  margin-top: 8px;
}
.md-list-bg-no-sep {
  background: #fff;
  padding: 8px;
}
.md-list-bg-no-sep li > .md-list-content {
  padding: 0 4px;
}
.md-list-outside > li {
  padding: 0;
}
.md-list-outside > li > .md-list-content {
  padding: 8px 16px;
  display: block;
  color: #212121;
}
.md-list-outside > li.md-list-item-active,
.md-list-outside > li:hover:not(.heading_list) {
  background: rgba(0, 0, 0, 0.085);
}
.md-list-outside > li.heading_list {
  padding: 32px 16px 16px;
}
.md-list-outside.md-list-addon li {
  margin-left: 0;
}
.md-list-outside.md-list-addon li .md-list-addon-element {
  position: relative;
  top: auto;
  left: auto;
  float: left;
}
.md-list-outside.md-list-addon li .md-list-content {
  padding-left: 0;
}
.md-list-outside-wrapper {
  position: relative;
}
.md-list-outside-wrapper .md-list-outside-search {
  position: absolute;
  top: -46px;
  left: 16px;
  right: 16px;
  z-index: 1000;
}
.md-list-outside-wrapper .md-list-outside-search .md-input-wrapper {
  padding: 0;
}
.md-list-outside-wrapper
  .md-list-outside-search
  .md-input-wrapper
  .md-input-bar:after,
.md-list-outside-wrapper
  .md-list-outside-search
  .md-input-wrapper
  .md-input-bar:before {
  background: #fff;
}
.md-list-outside-wrapper .md-list-outside-search .md-input {
  border-bottom-color: transparent !important;
}
.md-list .prodpage-uk-nestable-list {
  padding-left: 0;
}
.md-list .prodpage-uk-nestable-list .prodpage-uk-nestable-item {
  padding-right: 0;
}
.md-list .prodpage-uk-nestable-item + .prodpage-uk-nestable-item {
  margin-top: 0;
}
.md-list-right.md-list-addon > li {
  margin-left: 0;
  margin-right: 64px;
}
.md-list-right.md-list-addon > li .md-list-addon-element {
  left: auto;
  right: -64px;
}
.prodpage-uk-touch .md-list-addon-element .prodpage-uk-nestable-handle {
  display: block !important;
}
.prodpage-uk-touch .md-list-content .md-list-action,
.prodpage-uk-touch .md-list-content .md-list-action-placeholder {
  display: block !important;
}
.prodpage-uk-touch .md-list-action-dropdown {
  display: block !important;
}

.card-box.products-box {
  box-sizing: border-box;
  padding-left: 15px;
  padding-bottom: 20px;
  display: inline-block;
  max-width: 27rem !important;
}
.pink-box {
  box-shadow: 0 2px 10px 0 rgba(255, 38, 138, 0.55);
  background-color: #ff268a;
}
.blue-box {
  box-shadow: 0 2px 10px 0 rgba(13, 132, 242, 0.36);
  background-color: #00448b;
}
.lightblue-box {
  box-shadow: 0 2px 10px 0 rgba(13, 132, 242, 0.36);
  background-color: #50bcff;
}
.orange-box {
  box-shadow: 0 2px 10px 0 rgba(245, 166, 35, 0.35);
  background-color: #f5a623;
}
.border-orange1 {
  border-color: #ff7f00 !important;
}
.border-green1 {
  border-color: #1a9347 !important;
}
.border-red1 {
  border-color: #e82828 !important;
}
.border-blue1 {
  border-color: #00448b !important;
}
.card-group {
  margin-bottom: 2.143rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
}
.card-block {
  position: relative;
  padding: 1.429rem;
  -webkit-box-flex: 1;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
.card.card-block {
  box-shadow: none;
}
@media (min-width: 480px) {
  .card-group {
    -webkit-flex-flow: row wrap;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
  }
  .card-group .card:first-child {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group .card {
    margin-bottom: 0;
    -webkit-box-flex: 1;
    -webkit-flex: 1 0 0%;
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
  }
}
.counter {
  text-align: center;
}
.vertical-align:before {
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  content: "";
}
.vertical-align-bottom,
.vertical-align-middle {
  display: inline-block;
  max-width: 100%;
  font-size: 1rem;
}
.vertical-align-middle {
  vertical-align: middle;
}
.counter-lg .counter-icon {
  font-size: 40px;
}
.counter-inverse .counter-icon {
  color: #00448b;
}
.counter-inverse {
  color: #303031;
}
.h-150 {
  height: 150px !important;
}
.modal-qr-block {
  width: 100%;
  position: relative;
  display: block;
  padding: 20px 10px 0px;
  text-align: center;
}
.modal-passport-block {
  width: 100%;
  position: relative;
  display: block;
  padding: 5px 10px 0px;
}
.option__image {
  max-height: 80px;
  margin-right: 10px;
}
.option__desc,
.option__image {
  display: inline-block;
  vertical-align: middle;
}
.option__desc {
  padding: rem(10px);
}
.option__title {
  font-size: rem(24px);
}
.option__small {
  margin-top: rem(10px);
  display: block;
}
.form__label {
  margin-top: 5px !important;
}
.badge__img {
  vertical-align: middle;
  float: right;
}
.badge__name {
  vertical-align: middle;
  margin-left: 5px;
  float: left;
}
.products-section {
  font-weight: bold;
  line-height: 1.22;
  color: #303031;
  margin-top: 0px;
  margin-bottom: 0px;
  text-align: left;
  padding-top: 0px;
  padding-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
}
.employeeheader {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  min-height: 40px;
  height: 100%;
  position: relative;
  background: #ffffff;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.employeeheader > .descriptionheader {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 16px 25px;
  border-bottom: 1px solid transparent;
}
.employeeheader > .descriptionheader .description-text-header-left h5 {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  color: #00448b;
}
.employeeheader > .descriptionheader .description-text-header-right {
  font-size: 13px;
  margin-left: auto;
  padding-left: 12px;
  color: #4e5764;
  font-weight: 500;
}
.employeeheader > .descriptionheader .description-text-header-right {
  display: block;
  margin-top: 30px;
}
.see-link {
  text-decoration: underline;
  font-size: 13px;
  font-weight: normal;
  line-height: 1.2;
  color: #00448b;
  cursor: pointer;
  float: right;
}
.btn-outline-danger:hover {
  color: #fff !important;
  background-color: #f44336;
  border-color: #f44336;
}
.btn-outline-danger {
  color: #f44336 !important;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.btn-secondary.btn-outline {
  color: #00448b !important;
  background-color: transparent;
  background-image: none;
  border: 1px solid #00448b;
}
.btn-secondary.btn-outline:hover {
  color: #fff !important;
  background-color: #00448b;
  border-color: #00448b;
}
.btn-outline-default:hover {
  color: #fff !important;
  background-color: #4e5764;
  border-color: #4e5764;
}
.btn-outline-default {
  color: #4e5764 !important;
  background-color: transparent;
  background-image: none;
  border-color: #4e5764;
}
.nav-pills.nav-employees .nav-link.active,
.nav-pills.nav-employees .show > .nav-link {
  color: #fff;
  background-color: #00448b;
}
.nav-pills.nav-employees .nav-link {
  -webkit-border-radius: 18px;
  border-radius: 18px;
}
.nav-pills.nav-employees .nav-link {
  height: 32px;
  color: #00448b;
  text-decoration: none;
  border: 1px solid #00448b;
  line-height: 32px;
  margin-right: 10px;
}
.nav-pills.nav-employees .nav-link:hover,
.nav-pills.nav-employees .nav-link:focus {
  text-decoration: none;
  color: #fff !important;
  background-color: #00448b;
}
.tab-content.employee-tab-content {
  padding: 10px 0px;
}

.md-card.products-card .md-card-head .list-group .list-group-item {
  border-radius: 6px;
  background-color: transparent;
  min-height: 7.8rem !important;
}
.md-card.products-card .md-card-head .list-group .list-group-item > .avatar {
  -webkit-border-radius: 0px !important;
  border-radius: 0px !important;
}
.md-card.products-card .md-card-head .list-group .list-group-item > .avatar i {
  font-size: 40px;
  width: 40px;
  height: 40px;
  line-height: 40px;
  color: #00448b;
}
.md-card.products-card
  .md-card-head
  .list-group
  .list-group-item
  > .secondary-container {
  margin-top: 0px;
  margin-right: -5px;
}
.md-card.products-card
  .md-card-head
  .list-group
  .list-group-item
  > .secondary-container
  i {
  font-size: 20px;
  width: 16px;
  height: 16px;
  line-height: 16px;
  color: #00448b;
}
/* .md-card.products-card
  .md-card-head
  .list-group
  .list-group-item
  > .secondary-container
  .el-dropdown {
} */
.md-card.products-card
  .md-card-head
  .list-group
  .list-group-item
  > .secondary-container
  .el-dropdown
  .el-dropdown-link {
  cursor: pointer;
  color: #fff;
}
.md-card.products-card
  .md-card-head
  .list-group
  .list-group-item
  > .secondary-container
  .el-dropdown
  .el-dropdown-link i{
  cursor: pointer;
  color: #fff;
}
.md-card.products-card
  .md-card-head
  .list-group
  .list-group-item
  > .secondary-container
  .el-dropdown
  .el-dropdown-link
  .el-icon-arrow-down {
  font-size: 20px;
  width: 16px;
  height: 16px;
  line-height: 16px;
  color: #00448b;
}
.mediaprod .media-right .el-dropdown {
  color: #fff;
}
.mediaprod .media-right .el-dropdown .el-dropdown-link i {
  color: #fff;
  cursor: pointer;
  font-size: 20px;
  width: 16px;
  height: 16px;
  line-height: 16px;
}
.md-card.products-card .md-card-head .list-group .list-group-item.three-line {
  min-height: 10.8rem;
}
.md-card.products-card
  .md-card-head
  .list-group
  .list-group-item.three-line
  h3 {
  font-size: 14px;
  margin: 5px 0px 5px;
  line-height: 1.21;
  font-weight: bold;
  color: #303031;
  width: 145px;
}
.md-card.products-card
  .md-card-head
  .list-group
  .list-group-item.three-line
  h4 {
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.6px;
  margin: 1px 0 1px 0;
  color: #4e5764;
  width: 145px;
  height: 24px;
}
.md-card.products-card .md-card-head .list-group .list-group-item.three-line p {
  font-size: 1.3rem;
  font-weight: 500;
  letter-spacing: 0.01em;
  margin: 6px 0px 0px;
}
.md-card.products-card
  .md-card-head
  .list-group
  .list-group-item.three-line
  p
  button {
  margin: 0;
}
.md-card.products-card
  .md-card-head
  .list-group
  .list-group-item.three-line
  > .secondary-container {
  margin-top: 0px;
  margin-right: -5px;
}
.md-card.products-card
  .md-card-head
  .list-group
  .list-group-item.three-line
  > .secondary-container
  i {
  font-size: 20px;
  width: 16px;
  height: 16px;
  line-height: 16px;
  color: #00448b;
}
.md-card.products-card
  .md-card-head
  .list-group
  .list-group-item.three-line
  > .avatar {
  margin-top: 2.4rem;
}
.el-dropdown-menu__item {
  list-style: none;
  line-height: 36px;
  padding: 0 20px;
  margin: 0;
  font-size: 14px;
  color: #303031;
  cursor: pointer;
  outline: none;
}
.productspageHeader {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  min-height: 40px;
  position: relative;
  background: transparent;
  -webkit-box-shadow: none;
  box-shadow: none;
  border-radius: 4px;
}

.productspageHeader > .descriptionheader {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 8px 14px;
  border-bottom: 1px solid transparent;
}

.productspageHeader > .descriptionheader .description-text-header-left h5 {
  font-size: 15px;
  font-weight: 600;
  margin: 0;
  color: #00448b;
}

.productspageHeader > .descriptionheader .description-text-header-right {
  font-size: 13px;
  margin-left: auto;
  padding-left: 12px;
  color: #00448b;
  font-weight: 500;
}

.productspageHeader > .descriptionheader .description-text-header-right {
  display: block;
}

.productspageHeader > .descriptionheader .description-text-header-right i {
  color: #00448b;
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/ProductsPage.vue